import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import {
	type ValidationError,
	isFetchError,
	isValidationError,
} from '@atlassian/jira-fetch/src/utils/errors.tsx';

const meta = {
	id: 'GetSpaceKey',
	packageName: 'jiraSoftwareBacklog',
	teamName: 'starburst',
};

export async function getWhiteboardsUrl(
	cloudId: string,
	projectId: number,
	projectName: string,
): Promise<string> {
	let key = '';
	try {
		const cql = `type=space and title="${projectName}"`;
		const api = `/wiki/rest/api/search?cql=${encodeURIComponent(cql)}`;
		const res = await performGetRequest(api);
		key = res?.results?.[0]?.space?.key ?? '';
	} catch (error) {
		if (isFetchError(error)) {
			if (error.statusCode === 403) {
				// Do nothing, just fall through to return URL without spaceKey
			} else {
				fireErrorAnalytics({
					meta,
					attributes: {
						traceId: error.traceId,
						statusCode: error.statusCode,
					},
					error: new Error(
						`Fetch Error when searching for a space key with a given project name, status code: ${error.statusCode}`,
					),
				});
			}
			/* eslint-disable-next-line @typescript-eslint/consistent-type-assertions */
		} else if (typeof error === 'object' && error !== null && isValidationError(error as Error)) {
			/* eslint-disable-next-line @typescript-eslint/consistent-type-assertions */
			const validationError = error as ValidationError;
			fireErrorAnalytics({
				meta,
				attributes: {
					traceId: validationError.traceId,
					statusCode: validationError.statusCode,
				},
				error: new Error(
					`Validation Error when searching for a space key with a given project name, status code: ${validationError.statusCode}`,
				),
			});
		} else if (error instanceof Error) {
			fireErrorAnalytics({
				meta,
				skipSentry: true,
				error: new Error('Unknown error when searching for a space key with a given project name'),
			});
		}
	}
	return `/wiki/create-content/whiteboard?openJiraImportTool=true&cloudId=${cloudId}&projectUuid=${projectId}&insertTemplateWithKey=prioritization-experiment&spaceKey=${key}&withFallback=True`;
}
